import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/chromecast': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M447.8 64h0.2c23.6 0 42.7 19.1 42.7 42.7v298.6c0 23.6-19.1 42.7-42.7 42.7v0h-149.4v-42.7h149.2v-298.6h-383.8v63.9h-42.7v-63.9c0-23.6 19.1-42.7 42.7-42.7h383.8zM21.3 383.6c35.3 0 63.9 28.6 63.9 63.9v0h-63.9v-63.9zM21.3 298.3l0 0.3h0.3c82.2 0.1 149 66.9 149 149.2v0.2h-42.7v-0.3 0c0-58.9-47.8-106.6-106.6-106.6h0v-42.7zM21.3 213v0.3c129.5 0.4 234.3 105.2 234.8 234.6h-42.7v-0.5c-0.1-106-86.1-191.8-192.1-191.8v-42.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/chromecast.js
// module id = 756
// module chunks = 0